import React from "react";
import _flatten from "lodash/flatten";
import _compact from "lodash/compact";
import { Route, Routes } from "react-router-dom";
import { CustomerAdminLayout } from ".";
import CustomerAdminRouteMaster from "./routeMaster";
import { compose } from "redux";
import { connect } from "react-redux";
import FourNotFour from "../FourNotFour";
import ExternalApp from "./ExternalApp";

const CustomerAdminRouter = (props) => {
  const AppRoute = props.AppRoute;

  return (
    <Routes>
      {CustomerAdminRouteMaster.map((route, idx) => {
        if (!route.component) return null;
        return (
          <Route
            key={idx}
            path={route.path}
            element={
              <AppRoute
                layout={CustomerAdminLayout}
                component={route.component}
                pathkey={route.key}
                routeObj={route}
              />
            }
          />
        );
      })}
      {_flatten(_compact(CustomerAdminRouteMaster.map((x) => x.collapse))).map(
        (route, idx) => {
          if (!route.component) return null;
          if (
            route.customer_type &&
            !route.customer_type.includes(
              props.currentUser.company.customer_type
            )
          ) {
            return null;
          }
          return (
            <Route
              key={`sub-${idx}`}
              path={route.path}
              element={
                <AppRoute
                  layout={CustomerAdminLayout}
                  component={route.component}
                  pathkey={route.key}
                  routeObj={route}
                />
              }
            />
          );
        }
      )}
      {renderCustomAppsRoutes(props)}

      <Route path="*" element={<FourNotFour />} />
    </Routes>
  );
};

// ponytail: dynamic require → import.meta.glob (Vite native, eager bundle)
const appRoutesGlob = import.meta.glob("./Apps/*/routes.{jsx,js}", {
  eager: true,
});

const renderCustomAppsRoutes = (props) => {
  const AppRoute = props.AppRoute;
  const routes = [];
  (
    [
      ...(props.currentUser.apps || []),
      { app_slug: "microwave-heatmap", is_installed: true },
    ] || []
  )
    .filter((x) => x.is_installed)
    .forEach((app) => {
      if (app.app_type === "External") {
        routes.push(
          <Route
            key={`${app.app_slug}-ext`}
            path={`/${app.app_slug}/*`}
            element={
              <AppRoute
                layout={CustomerAdminLayout}
                component={ExternalApp}
                routeObj={app || {}}
                src={app.external_url}
              />
            }
          />
        );
        return;
      }
      let extraRoutes = [];
      const key = Object.keys(appRoutesGlob).find((k) =>
        k.includes(`/${app.app_slug}/routes.`)
      );
      if (key) extraRoutes = appRoutesGlob[key].default || [];
      extraRoutes.forEach((er, index) => {
        routes.push(
          <Route
            key={`${app.app_slug}-${index}`}
            path={`/${app.app_slug}${er.path === "/" ? "" : er.path}`.replace(/\/$/, "") || "/"}
            element={
              <AppRoute
                layout={CustomerAdminLayout}
                component={er.component}
                routeObj={{}}
              />
            }
          />
        );
      });
    });
  return routes;
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.userReducer.current_user,
  };
};

export default compose(connect(mapStateToProps))(CustomerAdminRouter);
